import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './IconButton.scss';

type Props = {
  icon: React.ComponentType;
  variant?: 'default' | 'ghost';
  disabled?: boolean;
  ariaLabel: string;
  onClick?: () => void;
};

function IconButton(props: Props) {
  const { icon: Icon, variant = 'default', ariaLabel, disabled, onClick } = props;
  const { t } = useTranslation();

  const className = cn(styles.button, { [styles.ghost]: variant === 'ghost' });

  return (
    <button className={className} aria-label={t(ariaLabel)} onClick={onClick} disabled={disabled}>
      <Icon />
    </button>
  );
}

export default React.memo(IconButton);
